import BaseApi, { FetchMethodType } from 'api/BaseApi';
import { ICuroApplication } from 'types/curo/CuroApplication';

interface IGetSigningUrlResponse {
  signingUrl: string;
}

interface IOneSpanSignApi {
  getSigningUrl: () => Promise<IGetSigningUrlResponse>;
  completeSigning: () => Promise<ICuroApplication>;
}

export default class OneSpanSignApi extends BaseApi implements IOneSpanSignApi {
  public async getSigningUrl(): Promise<IGetSigningUrlResponse> {
    const response = await this.fetch<IGetSigningUrlResponse>('/one-span-sign', {
      method: FetchMethodType.GET,
    });

    return response;
  }

  public async completeSigning(): Promise<ICuroApplication> {
    const response = await this.fetch<ICuroApplication>('/one-span-sign', {
      method: FetchMethodType.POST,
    });

    return response;
  }
}
